import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Tooltip, Dialog, DialogContent, DialogTitle, DialogActions, Button } from "@material-ui/core";
import { Check as CheckIcon } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  colorPickerContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    maxWidth: 200,
  },
  colorItem: {
    width: 30,
    height: 30,
    borderRadius: 15,
    margin: theme.spacing(0.5),
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid transparent",
    "&:hover": {
      border: `2px solid ${theme.palette.grey[300]}`,
    },
  },
  colorItemSelected: {
    border: `2px solid ${theme.palette.grey[800]}`,
  },
  checkIcon: {
    color: "#fff",
    fontSize: 18,
  },
}));

// Array padrão de cores
const defaultColors = [
  "#e91e63", // rosa
  "#9c27b0", // roxo
  "#673ab7", // roxo escuro
  "#3f51b5", // índigo
  "#2196f3", // azul
  "#03a9f4", // azul claro
  "#00bcd4", // ciano
  "#009688", // verde-azulado
  "#4caf50", // verde
  "#8bc34a", // verde claro
  "#cddc39", // lima
  "#ffeb3b", // amarelo
  "#ffc107", // âmbar
  "#ff9800", // laranja
  "#ff5722", // laranja escuro
  "#795548", // marrom
  "#607d8b", // azul acinzentado
  "#f44336", // vermelho
];

const ColorPicker = ({ 
  open, 
  handleClose, 
  colors = defaultColors, 
  color = defaultColors[0], 
  onChange 
}) => {
  const classes = useStyles();

  const handleColorSelect = (selectedColor) => {
    if (onChange) {
      onChange(selectedColor);
    }
    if (handleClose) {
      handleClose();
    }
  };

  // Se for usado como um modal
  if (open !== undefined) {
    return (
      <Dialog open={open} onClose={handleClose} maxWidth="xs">
        <DialogTitle>Selecione uma cor</DialogTitle>
        <DialogContent>
          <div className={classes.colorPickerContainer}>
            {colors.map((c) => (
              <Tooltip key={c} title={c} arrow>
                <div
                  className={`${classes.colorItem} ${
                    color === c ? classes.colorItemSelected : ""
                  }`}
                  style={{ backgroundColor: c }}
                  onClick={() => handleColorSelect(c)}
                >
                  {color === c && <CheckIcon className={classes.checkIcon} />}
                </div>
              </Tooltip>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  // Se for usado como um componente inline
  return (
    <div className={classes.colorPickerContainer}>
      {colors.map((c) => (
        <Tooltip key={c} title={c} arrow>
          <div
            className={`${classes.colorItem} ${
              color === c ? classes.colorItemSelected : ""
            }`}
            style={{ backgroundColor: c }}
            onClick={() => handleColorSelect(c)}
          >
            {color === c && <CheckIcon className={classes.checkIcon} />}
          </div>
        </Tooltip>
      ))}
    </div>
  );
};

export default ColorPicker;
